import { API_URL, inServer } from "core-web/constants";
import { get, request } from "core-web/libs/GrebbCommerceAPI/util";

import { getModel } from "core-web/state";

export default async (partNo, parameters = {}, url, applicationId, getHistoricalPrice = false) => {
    if (!parameters || typeof parameters !== "object") {
        parameters = {};
    }

    if (getHistoricalPrice) {
        parameters["get_historical_price"] = getHistoricalPrice;
    }

    let response;
    if (!API_URL && inServer && url) {
        response = await request({
            method: "GET",
            path: `/frontend/product/no/${partNo}?application_id=${applicationId}`,
            data: parameters,
            baseUrl: url,
        });
        if (response) {
            return await response.body();
        }
    }

    response = await get(`/frontend/product/no/${partNo}`, {
        application_id: applicationId || getModel("application").applicationId,
        ...parameters,
    });

    return await response.body();
};
